module.exports = ".navbar-burger {\r\n    margin-left: 0;\r\n}\r\n"